/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export enum EResourceParentType {
    GROUP = 1,
    FOLDER = 2,
    PROGRAM = 3,
    ELEMENT = 4,
    QUESTION = 5,
    CLASS = 6,
}

interface IInput {
    parent_id: number;
    parent_type: EResourceParentType;
    setup_data: string;
}

interface IOutput {
    result: boolean;
}

export const updateSetup = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.UPDATE_SETUP, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const updateSetupSync = fetchDataSync(updateSetup);
